import { createContext, useContext, useMemo } from 'react';
import { useFleetHealth } from '../../../../queries/screenHealth';

/**
 * One customer-health fetch for the whole Screens page, shared with every card (chips) and the "needs you" banner.
 * Cards never fetch on their own, so 50 screens = ONE request. The data is the backend's `customer` block, derived from the
 * same presence function the Screens list uses, so the chips can never disagree with the card's own status.
 */
const HealthContext = createContext({ byId: {}, customer: null, isLoading: false, isError: false, refetch: () => {} });

export function HealthProvider({ children }) {
  const q = useFleetHealth();
  const value = useMemo(() => {
    const byId = {};
    (q.data?.screens || []).forEach((s) => { byId[s.id] = s; });
    return { byId, customer: q.data || null, isLoading: q.isLoading, isError: q.isError, refetch: q.refetch };
  }, [q.data, q.isLoading, q.isError, q.refetch]);
  return <HealthContext.Provider value={value}>{children}</HealthContext.Provider>;
}

export const useHealth = () => useContext(HealthContext);
/** The customer health entry for one screen, or null while loading / unknown (the card then simply shows no chips). */
export const useScreenHealthEntry = (id) => useContext(HealthContext).byId[id] || null;

/** Test seam: feed the cards a fixed {id: entry} map without any fetch. */
export const HealthContextForTests = ({ byId, children }) => <HealthContext.Provider value={{ byId, customer: null, isLoading: false, isError: false, refetch: () => {} }}>{children}</HealthContext.Provider>;
